import ButtonLink from "plos/src/components/links/ButtonLink";
import { useTranslation } from "react-i18next";
import { ChevronRight } from "../../icons/Chevrons";
import EntryInfoPanel from "../EntryInfoPanel";
import LeagueSummary from "../LeagueSummary";
import { LeaguesPanelProps } from "./types";

const LeaguesPanel = ({
  entry,
  broadcasterLeagues,
  filteredSystemClassicLeagues,
  privateClassicLeagues,
  privateH2HLeagues,
  publicClassicLeagues,
  publicH2HLeagues,
}: LeaguesPanelProps) => {
  const { t } = useTranslation("leaguesAndCups");

  const headerAction = (
    <ButtonLink appearance="tonal" size="small" to="/leagues">
      {t("createJoinLeagues", "Create/Join Leagues")}
      <ChevronRight height={10} width={10} />
    </ButtonLink>
  );

  return (
    <EntryInfoPanel
      title={t("myLeagues", "My Leagues")}
      headerAction={headerAction}
    >
      {broadcasterLeagues.length > 0 && (
        <LeagueSummary
          title={t("broadcasterLeagues", "Broadcaster Leagues")}
          leagues={broadcasterLeagues}
          entry={entry}
        />
      )}
      {privateClassicLeagues.length > 0 && (
        <LeagueSummary
          title={t("privateClassicLeagues", "Invitational Classic Leagues")}
          leagues={privateClassicLeagues}
          entry={entry}
        />
      )}
      {privateH2HLeagues.length > 0 && (
        <LeagueSummary
          title={t("privateH2HLeagues", "Invitational Head-to-Head Leagues")}
          leagues={privateH2HLeagues}
          entry={entry}
        />
      )}
      {publicClassicLeagues.length > 0 && (
        <LeagueSummary
          title={t("publicClassicLeagues", "Public Classic Leagues")}
          leagues={publicClassicLeagues}
          entry={entry}
        />
      )}
      {publicH2HLeagues.length > 0 && (
        <LeagueSummary
          title={t("publicH2HLeagues", "Public Head-to-Head Leagues")}
          leagues={publicH2HLeagues}
          entry={entry}
        />
      )}
      <LeagueSummary
        title={t("systemPublicLeagues", "General Leagues")}
        leagues={filteredSystemClassicLeagues}
        entry={entry}
      />
    </EntryInfoPanel>
  );
};

export default LeaguesPanel;
